// src/compoonents/Sidebar/Sidebar.tsx

import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiBriefcase,
  FiChevronDown,
  FiCoffee,
  FiLink2,
  FiPackage,
  FiShoppingBag,
  FiGrid,
} from "react-icons/fi";
import "./Sidebar.css";

import logo from "../../assets/images/navo-logo.png";
import dashboardIcon from "../../assets/images/dashboardicon.png";
import customersIcon from "../../assets/images/customers.png";
import shipmentIcon from "../../assets/images/shipment-icon.png";
import quoteIcon from "../../assets/images/quote-icon.png";
import trackingIcon from "../../assets/images/trackingicon.png";
import fxIcon from "../../assets/images/fximage.png";
import transactionIcon from "../../assets/images/transactionicon.png";
import supportTicketIcon from "../../assets/images/support.png";
import auditManagementIcon from "../../assets/images/usermagg.png";
import userManagementIcon from "../../assets/images/usermgt.png";
import settingsIcon from "../../assets/images/settings.png";
import logoutIcon from "../../assets/images/logoutIcon.png";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const SHOP_LINKS = [
  { path: "/purchase-orders", label: "Fooding", Icon: FiCoffee },
  { path: "/shop-with-link", label: "Shop With Link", Icon: FiLink2 },
  { path: "/naija-shop", label: "Naija Shop", Icon: FiShoppingBag },
  { path: "/amazon", label: "Amazon", Icon: FiPackage },
] as const;

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const location = useLocation();

  const isShopRouteActive = SHOP_LINKS.some((item) =>
    location.pathname.startsWith(item.path)
  );
  const [shopsOpen, setShopsOpen] = useState(isShopRouteActive);

  useEffect(() => {
    if (isShopRouteActive) setShopsOpen(true);
  }, [isShopRouteActive]);

  const getNavItemClass = (path: string) =>
    location.pathname.startsWith(path) && path !== "/" ? "active" : "";

  const dashboardClass =
    location.pathname === "/" || location.pathname === "/dashboard"
      ? "active"
      : "";

  const handleLinkClick = () => onClose();

  return (
    <aside className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-logo">
        <Link to="/" onClick={handleLinkClick}>
          <img src={logo} alt="Navo+ Logo" />
        </Link>
      </div>
      <nav className="sidebar-nav">
        <ul>
          <li className={dashboardClass}>
            <Link to="/dashboard" onClick={handleLinkClick}>
              <img src={dashboardIcon} alt="" /> Dashboard
            </Link>
          </li>
          <li className={getNavItemClass("/customers")}>
            <Link to="/customers" onClick={handleLinkClick}>
              <img src={customersIcon} alt="" /> Customers
            </Link>
          </li>
          <li className={getNavItemClass("/shipments")}>
            <Link to="/shipments" onClick={handleLinkClick}>
              <img src={shipmentIcon} alt="" /> Shipments
            </Link>
          </li>
          <li className={getNavItemClass("/quote-request")}>
            <Link to="/quote-request" onClick={handleLinkClick}>
              <img src={quoteIcon} alt="" /> Quote Request
            </Link>
          </li>
          <li className={getNavItemClass("/tracking")}>
            <Link to="/tracking" onClick={handleLinkClick}>
              <img src={trackingIcon} alt="" /> Tracking Mgt.
            </Link>
          </li>

          <li className={`sidebar-group${isShopRouteActive ? " active-group" : ""}`}>
            <button
              type="button"
              className={`sidebar-group-toggle${shopsOpen ? " open" : ""}`}
              onClick={() => setShopsOpen((open) => !open)}
              aria-expanded={shopsOpen}
            >
              <FiGrid className="nav-icon-svg" aria-hidden />
              <span>Shops & Orders</span>
              <FiChevronDown className="sidebar-group-chevron" aria-hidden />
            </button>
            {shopsOpen && (
              <ul className="sidebar-subnav">
                {SHOP_LINKS.map(({ path, label, Icon }) => (
                  <li
                    key={path}
                    className={location.pathname.startsWith(path) ? "active" : ""}
                  >
                    <Link to={path} onClick={handleLinkClick}>
                      <Icon className="nav-icon-svg" aria-hidden />
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>

          <li className={getNavItemClass("/vendors")}>
            <Link to="/vendors" onClick={handleLinkClick}>
              <FiBriefcase className="nav-icon-svg" aria-hidden /> Vendors
            </Link>
          </li>

          <li className={getNavItemClass("/fx")}>
            <Link to="/fx" onClick={handleLinkClick}>
              <img src={fxIcon} alt="" /> FX
            </Link>
          </li>
          <li className={getNavItemClass("/transactions")}>
            <Link to="/transactions" onClick={handleLinkClick}>
              <img src={transactionIcon} alt="" /> Transaction
            </Link>
          </li>
          <li className={getNavItemClass("/support")}>
            <Link to="/support" onClick={handleLinkClick}>
              <img src={supportTicketIcon} alt="" /> Support Ticket
            </Link>
          </li>
        </ul>
        <hr className="sidebar-divider" />
        <ul>
          <li className={getNavItemClass("/audit")}>
            <Link to="/audit" onClick={handleLinkClick}>
              <img src={auditManagementIcon} alt="" /> Audit Mgt.
            </Link>
          </li>
          <li className={getNavItemClass("/user-management")}>
            <Link to="/user-management" onClick={handleLinkClick}>
              <img src={userManagementIcon} alt="" /> User Mgt.
            </Link>
          </li>
          <li className={getNavItemClass("/settings")}>
            <Link to="/settings" onClick={handleLinkClick}>
              <img src={settingsIcon} alt="" /> Settings
            </Link>
          </li>
        </ul>
      </nav>
      <div className="sidebar-logout">
        <a href="/login">
          <img src={logoutIcon} alt="" /> Logout
        </a>
      </div>
    </aside>
  );
};

export default Sidebar;
